export default "__VITE_ASSET__B_HKFC$5__"